export const BIO = [
  {
    year: 2020,
    title: {
      name: "Seplom",
      cargo: "Graphic Designer",
    },
    description:
      "Development of ads, covers, and social media using design methodologies such as Design Thinking",
    details: ["Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign"],
  },
  {
    year: 2021,
    title: {
      name: "Seplom",
      cargo: "User Inferface Design",
    },
    description: " Working with Figma and Adobe XD",
    details: [
      "Design of web and mobile interfaces",
      "Development of user interface and user experience",
    ],
  },
  {
    year: 2022,
    title: {
      name: "Fiver",
      cargo: "Frontend Develooper",
    },
    description:
      "Freelance projects with Technologies like Nextjs, Reactjs, Redux and Gatsby",
    details: ["Reactjs", "Nextjs", "Java", " SpringBoot"],
  },
];
